import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import CrashReportsEditIndexPage from "./pages/Index/pages/Index";
import CrashReportEditIndexOccurrencesPage from "./pages/Index/pages/Occurrences";
import CrashReportOccurrencePage from "./pages/Occurrence";

const CrashReportsEditPage = (props: RouteComponentProps) => {
	return (
		<Switch>
			<Route exact path={`${props.match.url}/:crashReportId`} component={CrashReportsEditIndexPage} />
			<Route
				exact
				path={`${props.match.url}/:crashReportId/occurrences`}
				component={CrashReportEditIndexOccurrencesPage}
			/>
			<Route
				exact
				path={`${props.match.url}/:crashReportId/occurrences/:occurrenceId`}
				component={CrashReportOccurrencePage}
			/>
		</Switch>
	);
};

export default CrashReportsEditPage;
